<my-content placeholder="main">
  <div class="popupBlocker" *ngIf="showEmergencyPopup"></div>
  <div class="popupContainer" *ngIf="showEmergencyPopup">
    <div class="popupHeader">
      <div class="popupTitle">{{ 'Master.PopupTitle' | translate:pageContentParams }}</div>
      <div class="popupClose buttonPointer" (click)="toggleEmergencyPopup(false)">X</div>
    </div>
    <div class="popupBody">
      <div class="popupContent" *ngIf="!_metaDataService.IsAAHomeInspection(jobDataService.trade.id)">
        Call us now on <b>{{ metaData.contactEmergencyNumber }}</b>
        <span *ngIf="clientID == clients.AANZ"> and we will arrange to send a plumber as soon as possible.</span>
        <span *ngIf="clientID != clients.AANZ">{{ clientID == clients.RACWA ? ' at any time and one of our team will be able to help you' : ' between the hours of ' + metaData.contactPhoneHours + ' and we will arrange to send a plumber as soon as possible' }}.</span>
      </div>
      <div class="popupContent" *ngIf="jobDataService.trade.id == tradeTypes.AAHealthyHomeInspection">
        <span>Please contact us on <b><u>info@aahome.co.nz</u></b> and provide more details and we will arrange our representative to contact you as soon as possible.</span>
      </div>
      <div class="popupContent" *ngIf="jobDataService.trade.id == tradeTypes.AABuildingInspection">
        <p>The building report is suitable for pre-purchase, pre-sale, or for insurance purposes.</p>
        <p>The building report is completed to the NZ Standard 4360:2005.</p>
        <p>It covers 10 points of interest including site, sub floor, exterior, roof exterior (safety dependent), roof space if accessible, interior, services, and ancillary spaces. There are also moisture readings taken throughout the property and a visual check on the plumbing and wiring.</p>
        <p>The building report is undertaken by a qualified builder or licensed building practitioner with full Professional Indemnity and Public Liability insurance, including an endorsement that covers weathertightness.</p>
      </div>
      <div class="popupContent" *ngIf="jobDataService.trade.id == tradeTypes.AARentalInspection">
        <p>The Rental Inspection Report will provide you with all the information you need to ensure both Insurance and Tenancy Tribunal compliance for your rental property. This will include photos throughout the property for your records and comparisons.</p>
        <p>It also assesses the property on cleanliness, any maintenance or wear and tear, and any tenant damage, and so is ideal for when you have a change in tenancy to ensure you get the correct amount of bond back to your tenant, and address any maintenance needs prior to your new tenants moving in.</p>
        <p>This report is usually completed within 24 hours following the onsite inspection.</p>
      </div>
      <div class="popupContent" *ngIf="jobDataService.trade.id == tradeTypes.AAMethamphetamineInspection">
        <p>The methamphetamine test is conducted by an NZQA qualified tester who takes swabs throughout the property in line with the NZ Standard 8510:2017 for meth testing.</p>
        <p>The inspector then sends the samples to an independent IANZ accredited laboratory. The lab will analyse the samples and provide us with a yes/no answer to the presence of methamphetamine, and a level if any is detected. This result is returned within 3 working days and you receive the laboratory sheet and a full report outlining what the result may mean for your property.</p>
        <p>This test is a composite so you receive one combined result from the swabs taken and is suitable for screening purposes, such as if you are going to be renting out your property, or after a tenant has moved out. It can also be used if you are looking to purchase, or as an added tool pre-sale, especially if the property has been used as a rental previously.</p>
      </div>
      <div class="popupContent" *ngIf="jobDataService.trade.id == tradeTypes.AAAsbestosInspection">
        <p>Our inspectors are Fibresafe trained to take samples safely and discreetly, and send them off to an independent IANZ accredited Laboratory for analysis.</p>
        <p>Generally, only one sample is required from each product type/material. Sometimes our inspector will take pieces from multiple locations.</p>
        <p>You will receive a report and laboratory results outlining if the material tested contains asbestos.</p>
      </div>
      <div class="popupButtons">
        <div class="standardButton buttonPointer" (click)="toggleEmergencyPopup(false)">Confirm</div>
      </div>
    </div>
  </div>
  
  <!-- CONFIRM POPUP -->
  <div class="popupBlocker" *ngIf="showConfirmPopup"></div>
  <div class="popupContainer" *ngIf="showConfirmPopup">
    <div class="popupHeader">
      <div class="popupTitle">PLEASE NOTE</div>
      <div class="popupClose buttonPointer" (click)="closeConfirmPopup(false)">X</div>
    </div>
    <div class="popupBody">
      <div class="popupContent" [innerHtml]="confirmPopupContent"></div>
      <div class="popupButtons">
        <!-- <div class="standardButton doubleButtons buttonPointer" (click)="closeConfirmPopup(false)">Cancel</div> -->
        <div class="standardButton doubleButtons buttonPointer" (click)="closeConfirmPopup(true)">Confirm</div>
      </div>
    </div>
  </div>
  <!-- CONFIRM POPUP -->

  <div class="stepContainer" *ngIf="showPostcodeCheck">
    <div class="postcodeStep">
      <div class="stepTitle">{{ 'Start.PostcodeCheckTitle' | translate:pageContentParams }}</div>
      <div class="stepDescription">{{ 'Start.CoverageArea' | translate:pageContentParams }}</div>
      <input type="tel" onkeydown = "if (event.keyCode == 13) document.getElementById('btnSearch').click()" placeholder="Enter your postcode" [(ngModel)]="postcode" class="postcodeText" />
      <button type="button" id = "btnSearch" (click)="checkPostcode()" class="wizardButton searchNowButton">{{ 'Start.CheckButton' | translate:pageContentParams }}</button>
    </div>
  </div>
  
  <div class="stepContainer" *ngIf="showMemberShipCheck">
      <div style="text-align: center;">
        <div class="stepTitleRaw">{{ jobDataService.capability.memberShipConfig.question }}</div>
        <div class="stepDescription">{{ jobDataService.capability.memberShipConfig.description }}</div>
        <div *ngIf="jobDataService.capability.memberShipConfig.questionType === questionTypes.YesNo">
          <div class="yesNoButtonContainer">
            <div class="optionSelect standardButton buttonPointer yesNoButton"
                (click)="setMemberShipAnswer(true)">{{ 'Master.YesButton' | translate:pageContentParams }}</div>
            <div class="optionSelect standardButton buttonPointer yesNoButton"
              (click)="setMemberShipAnswer(false)">{{ 'Master.NoButton' | translate:pageContentParams }}</div>
          </div>
        </div>
    </div>
  </div>
 
  <div *ngIf="showAreaNotCovered" class="stepContainer">
    <div class="postcodeStep">
      <div class="stepTitle">{{ 'Start.PostcodeNotCoveredTitle' | translate:pageContentParams }}</div>
      <div *ngIf="clientID != clients.AANZ">
        <div class="stepDescription">{{ 'Start.PostcodeNotCoveredSubTitle' | translate:pageContentParams }}</div>
        <div class="stepTitle notAvailablePhone"><a href="tel:{{ metaData.contactPhoneNumber }}">{{ metaData.contactPhoneNumber }}</a></div>
      </div>
    </div>
  </div>

  <div *ngIf="showServicesList" class="stepContainer" style="margin-bottom: 30px;">
    <div class="stepTitle">{{ trade.name.toUpperCase() }} {{ 'Start.ServicesTitle' | translate:pageContentParams }}</div>
    <div class="stepDescription">{{ 'Start.ServicesSubTitle' | translate:pageContentParams }}</div>
    
    <div *ngFor="let jts of jobTypeSelectors">
      <div  *ngIf= "jts.jobType.name != 'Installation - Air Conditioning or Heat Pump'">
        <div class="jobTypeContainer greyBox buttonPointer" [class.selected]="jts.selected == true" (click)="jobTypeClick(jts)">
          <div class="jobTypeLayout">
            <div class="jobTypeIconLayout">
              <div class="jobTypeIcon" [style.visibility]="jts.jobType.hideIcon ? 'hidden' : 'visible'">
                <img src="assets/img/{{ clientID }}/icons/jobtypes/{{ jts.jobType.icon }}" alt="" onerror="this.onerror=null; this.remove();"/>
              </div>
            </div>
            <div class="jobTypeName">
              {{ jts.jobType.name }}
              <br />
              <span class="inclusions">{{ jts.jobType.inclusions }}</span>
            </div>
          </div>
        </div>
      </div>

      <div  *ngIf= "jts.jobType.name == 'Installation - Air Conditioning or Heat Pump'">
        <div class="jobTypeContainer greyBox buttonPointer" [class.selected]="jts.selected == true" (click)="onNavigate('https://www.aa.co.nz/home-services/book-a-job-quote/')">
          <div class="jobTypeIcon" [style.visibility]="jts.jobType.hideIcon ? 'hidden' : 'visible'">
            <img src="assets/img/{{ clientID }}/icons/jobtypes/{{ jts.jobType.icon }}" alt="" onerror="this.onerror=null; this.remove();"/>
          </div>
          <div class="jobTypeName">
          <span class="inclusions">{{ jts.jobType.inclusions }}</span>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>

    <button type="button" class="wizardButton searchNowButton" *ngIf="bundlingEnabled == true" (click)="selectJobTypes()">{{ 'Start.SelectJobTypesButton' | translate:pageContentParams }}</button>
  </div>

  <div class="popupBlocker" *ngIf="emailSubmitLoading"></div>
  <div class="loadingSpinner" *ngIf="emailSubmitLoading">
    <fa-icon style="font-size: 3em;" [icon]="faSpinner" [spin]="true"></fa-icon>
  </div>

  <div class="popupBlocker" *ngIf="metaDataLoading"></div>
  <div class="loadingSpinner" *ngIf="metaDataLoading">
    <fa-icon style="font-size: 3em;" [icon]="faSpinner" [spin]="true"></fa-icon>
  </div>

</my-content>